/**
 * NovelSprig 品牌 - Home 页面配置
 */
import { homeCommonConfig } from './common'
import type { HomePageConfig } from './types'

/**
 * NovelSprig 品牌主题配置
 */
export const theme = {
  // 首页背景图
  homeBg: '/images/novelsprig/home-bg.svg',
  // 标签模块背景图
  tagsBg: '',

  // 标签按钮选中状态 (使用品牌主色)
  tagActiveBg: '#10B981',
  commonTagText: '#10B981',
  tagActiveText: '#FFFFFF',

  // 标签按钮未选中状态
  tagInactiveBg: '#D1FAE5',
  tagInactiveText: '#10B981',

  // Tab 激活状态渐变底部装饰线
  tabActiveGradient: 'linear-gradient(270deg, #F6F7F9 0%, #10B981 95%)',
  // Tab 激活状态文字和下划线颜色
  tabActiveColor: '#10B981',
  // Banner 已移至独立卡片，顶部不再使用叠图白字。
  onBannerTabActiveColor: '#10B981',
  onBannerTabInactiveColor: '#4B5563',
  onBannerSearchBg: '#FFFFFF',
  onBannerSearchPlaceholderColor: '#4B5563',
  // sticky-header 背景渐变
  stickyHeaderBg: '#ECFDF5',
  // 独立首页将 Banner 放在有边距的圆角卡片中。
  topBannerRadius: '20px',
  topBannerIndicatorActiveColor: '#10B981',
} as const

export const homeConfig: HomePageConfig = {
  theme,
  texts: homeCommonConfig.texts,
}
